import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import VueCookies from 'vue-cookies'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  // 首页
  {
    path: '/home',
    name: 'home',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Home/index.vue')
  },
  // 登录
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/login/index.vue')
  },
  // 重置密码
  {
    path: '/reset',
    name: 'reset',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/reset/index.vue')
  },
  // 精品文物
  {
    path: '/cultural',
    name: 'cultural',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/cultural/index.vue')
  },
  // 精品文物详情
  {
    path: '/culturalDetail',
    name: 'culturalDetail',
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/culturalDetail/index.vue'
      )
  },
  // 研究专题模块
  {
    path: '/yjztModule',
    name: 'yjztModule',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/yjztModule/index.vue')
  },
  // 研究专题研究详情
  {
    path: '/yjztDetail',
    name: 'yjztDetail',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/yjztDetail/index.vue')
  },
  // 红色文化研究
  {
    path: '/redCulture',
    name: 'RedCulture',
    component: () => import('@/views/monographic/redCulture/index.vue')
  },
  // 雨花英烈研究
  {
    path: '/rainHero',
    name: 'RainHero',
    component: () => import('@/views/monographic/rainHero/index.vue')
  },
  // 综合管理研究
  {
    path: '/zhglyj',
    name: 'zhglyj',
    component: () => import('@/views/monographic/zhglyj/index.vue')
  },
  // 红色文化研究-搜索更多
  {
    path: '/moreSearch',
    name: 'MoreSearch',
    component: () => import('@/views/monographic/moreSearch/index.vue')
  },
  // 红色文化研究-详情
  // {
  //   path: '/itemDeatil',
  //   name: 'ItemDeatil',
  //   component: () => import('@/views/monographic/detail/index.vue')
  // },
  // 个人中心（需登录）
  {
    path: '/personInfo',
    name: 'personInfo',
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/personInfo/index.vue')
  },
  // 纪念馆学术大数据
  {
    path: '/academic',
    name: 'academic',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/academic/index.vue')
  },
  // 帮助页面
  {
    path: '/help',
    name: 'help',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/help/index.vue')
  }
  // 后台管理系统
  // {
  //   path: '/backStage',
  //   name: 'backStage',
  //   redirect: '/backStage/home',
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ '../views/backStage/index.vue'),
  //   children: [
  //     {
  //       path: '/backStage/home',
  //       name: 'home',
  //       component: () =>
  //         import(
  //           /* webpackChunkName: "about" */ '../views/backStage/component/home.vue'
  //         )
  //     },
  //     {
  //       path: '/backStage/jpww',
  //       name: 'jpww',
  //       component: () =>
  //         import(
  //           /* webpackChunkName: "about" */ '../views/backStage/component/jpww.vue'
  //         )
  //     },
  //     {
  //       path: '/backStage/ztyj',
  //       name: 'ztyj',
  //       component: () =>
  //         import(
  //           /* webpackChunkName: "about" */ '../views/backStage/component/ztyj.vue'
  //         )
  //     },
  //     {
  //       path: '/backStage/hsdt',
  //       name: 'hsdt',
  //       component: () =>
  //         import(
  //           /* webpackChunkName: "about" */ '../views/backStage/component/hsdt.vue'
  //         )
  //     },
  //     {
  //       path: '/backStage/zhgl',
  //       name: 'zhgl',
  //       component: () =>
  //         import(
  //           /* webpackChunkName: "about" */ '../views/backStage/component/zhgl.vue'
  //         )
  //     }
  //     {
  //       path: "/backStage/bmgl",
  //       name: "bmgl",
  //       component: () =>
  //         import(
  //           /* webpackChunkName: "about" */ "../views/backStage/component/bmgl.vue"
  //         ),
  //     },
  //     {
  //       path: "/backStage/gwgl",
  //       name: "gwgl",
  //       component: () =>
  //         import(
  //           /* webpackChunkName: "about" */ "../views/backStage/component/gwgl.vue"
  //         ),
  //     },
  //   ]
  // }
]

const adminRoter = {
  path: '/backStage',
  name: 'backStage',
  redirect: '/backStage/home',
  meta: { requiresAuth: true, requiresAdmin: true },
  component: () =>
    import(/* webpackChunkName: "about" */ '../views/backStage/index.vue'),
  children: [
    {
      path: '/backStage/home',
      name: 'home',
      component: () =>
        import(
          /* webpackChunkName: "about" */ '../views/backStage/component/home.vue'
        )
    },
    {
      path: '/backStage/jpww',
      name: 'jpww',
      component: () =>
        import(
          /* webpackChunkName: "about" */ '../views/backStage/component/jpww.vue'
        )
    },
    {
      path: '/backStage/ztyj',
      name: 'ztyj',
      component: () =>
        import(
          /* webpackChunkName: "about" */ '../views/backStage/component/ztyj.vue'
        )
    },
    {
      path: '/backStage/hsdt',
      name: 'hsdt',
      component: () =>
        import(
          /* webpackChunkName: "about" */ '../views/backStage/component/hsdt.vue'
        )
    },
    {
      path: '/backStage/zhgl',
      name: 'zhgl',
      component: () =>
        import(
          /* webpackChunkName: "about" */ '../views/backStage/component/zhgl.vue'
        )
    },
    {
      path: '/backStage/bmgl',
      name: 'bmgl',
      component: () =>
        import(
          /* webpackChunkName: "about" */ '../views/backStage/component/bmgl.vue'
        )
    },
    {
      path: '/backStage/gwgl',
      name: 'gwgl',
      component: () =>
        import(
          /* webpackChunkName: "about" */ '../views/backStage/component/gwgl.vue'
        )
    }
  ]
}

// 后台路由固定注册：不再用 localStorage.name === 'admin'/'sa' 判断挂载
// （该判断用户改一下 localStorage 就能伪造绕过），改为路由守卫 + 后端接口鉴权
routes.push(adminRoter)

// JWT 不再持久化到 localStorage：启动时从后端 Set-Cookie 下发的 Cookie 恢复登录态（仅存内存 store）
// 若 Cookie 为 httpOnly（JS 读不到），则此处恢复不到，靠 Cookie 自动携带鉴权
const cookieToken = VueCookies.get('Authorization')
if (cookieToken) {
  store.commit('set_Authorization', cookieToken)
}

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch((err) => err)
}

const router = new VueRouter({
  routes
})

export default router
